// src/services/itemIdService.js
// D-300 (CRITICAL fix) — ONE platform-wide item_id counter.
//
// WHY: stock docs are keyed by item_id (inventory_summary/{item_id},
// site_inventory_summary/{site_id}_{item_id}). item_id used to be
// "max ITEM-number in THIS company + 1", so every company started at
// ITEM-00001 — a second company's first item overwrote the first company's
// stock doc. Two users of the same company adding items at the same moment
// also got the same number. A single counter reserved inside a transaction
// makes every item_id unique across the whole platform, for ever.
//
// Starts after 100000 so a new id can never meet an old per-company id
// (ITEM-00001 … ITEM-99999). Old items keep their ids — nothing is migrated.

import { doc, runTransaction, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

const COUNTER_ID = "item_id_global";
const START_AFTER = 100000;

// Reserves `count` new item_ids in ONE transaction → ["ITEM-100001", ...]
export const reserveItemIds = async (count = 1) => {
  const n   = Math.max(1, Math.floor(Number(count) || 1));
  const ref = doc(db, "system_counters", COUNTER_ID);

  const first = await runTransaction(db, async (tx) => {
    const snap  = await tx.get(ref);
    const last  = snap.exists() ? Number(snap.data().last_number || 0) : 0;
    const start = Math.max(last, START_AFTER) + 1;
    tx.set(ref, {
      counter_type: "item_id",
      last_number:  start + n - 1,
      updated_at:   serverTimestamp(),
    }, { merge: true });
    return start;
  });

  return Array.from({ length: n }, (_, i) => `ITEM-${first + i}`);
};

export const reserveItemId = async () => (await reserveItemIds(1))[0];